// src/contexts/LanguageContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

const detectLanguageFromPath = (pathname) => {
  const match = pathname.match(/\/recursero-ami-embed\/(es|en|pt)/);
  if (match) return match[1];
  return 'es';
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return detectLanguageFromPath(location.pathname);
  });

  useEffect(() => {
    const detected = detectLanguageFromPath(location.pathname);
    setCurrentLanguage(detected);
  }, [location.pathname]);

  const value = {
    currentLanguage,
    availableLanguages: ['es', 'en', 'pt']
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};